import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/salesMonitoringReport', request)
}

export {get}
